import { forwardRef, useEffect, useState } from 'react';
import clsx from 'clsx';
import styles from './spinner.module.less';
import { IS_IOS } from '../utils';

export type SpinnerProps = React.ComponentPropsWithoutRef<'span'> & {
  size?: 'lg' | 'md' | 'sm';
  timedContent?: Record<number, React.ReactNode>;
};

export const Spinner = forwardRef<HTMLSpanElement, SpinnerProps>(
  function Spinner(
    { className, children, timedContent, size = 'md', ...rest },
    ref
  ) {
    const [content, setContent] = useState(children);

    // Change text after a specified delay
    useEffect(() => {
      setContent(children); // Reset content
      Object.entries(timedContent || {}).forEach(([ms, jsx]) =>
        setTimeout(() => setContent(jsx), Number(ms))
      );
    }, [timedContent, children]);

    return (
      <span
        aria-live="polite"
        className={clsx(styles.spinner, styles[size], className)}
        ref={ref}
        role={IS_IOS ? undefined : 'progressbar'}
        tabIndex={0}
        {...rest}
      >
        <svg viewBox="25 25 50 50" aria-hidden="true">
          <circle cx="50" cy="50" r="20" />
          <circle cx="50" cy="50" r="20" />
        </svg>
        {content}
      </span>
    );
  }
);
